import {Tooltip} from '@dropbox/dig-components/tooltips';
import {UIIcon} from '@dropbox/dig-icons';
import {LockLine} from '@dropbox/dig-icons/assets';
import cx from 'classnames';
import {t} from 'i18next';

import styles from './MnpiMetricIndicator.module.css';

export const MnpiMetricIndicator = ({
  className,
  tooltip,
}: {
  className?: string;
  tooltip?: string;
}) => {
  const label = tooltip ?? t('mnpi_metric_tooltip').toString();

  return (
    <Tooltip title={label} placement="top">
      <span className={cx(styles.indicator, className)} aria-label={label} role="img">
        <UIIcon src={LockLine} size="small" />
      </span>
    </Tooltip>
  );
};
